var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6608 9.02757C16.963 8.74425 17.4381 8.75958 17.7214 9.06175C18.0043 9.36383 17.989 9.83807 17.6872 10.1213L13.197 14.3313C12.5238 14.9624 11.4756 14.9624 10.8024 14.3313L6.31319 10.1213C6.01103 9.83802 5.99574 9.36392 6.27901 9.06175C6.56232 8.75958 7.03641 8.74426 7.33858 9.02757L11.8288 13.2375C11.9249 13.3275 12.0745 13.3273 12.1706 13.2375L16.6608 9.02757Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.125e50e9cd28efa733e438015ec1d747.svg";
export { ForwardRef as ReactComponent };